import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/service/certificate1.png';
import _imports_1 from '@/assets/service/certificate2.png';
import _imports_2 from '@/assets/service/certificate3.png';
import _imports_3 from '@/assets/service/certificate4.png';
import _imports_4 from '@/assets/service/certificate5.png';
import _imports_5 from '@/assets/service/certificate6.png';
import _imports_6 from '@/assets/service/certificate7.png';
import _imports_7 from '@/assets/service/certificate8.png';
const _withScopeId = n => (_pushScopeId("data-v-8e7ddbbe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "certificate"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "ws_title"
}, "资质证书"), /*#__PURE__*/_createElementVNode("div", {
  class: "certificate-line"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "certificate-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "certificate-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "certificate-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "certificate-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})])]), /*#__PURE__*/_createElementVNode("div", {
  class: "certificate-line"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "certificate-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "certificate-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "certificate-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "certificate-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
})])]), /*#__PURE__*/_createElementVNode("div", {
  class: "button-container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "button",
  onclick: "if(mini_dialog.windowstate==1){ mini_dialog.maxwindow()}"
}, "在线咨询")])], -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3);
}